import $ from 'jquery'

if ($('#sort-by').length > 0) {
  const qp = {}

  // Preserve existing query parameters
  if (location.search.length) {
    var params = location.search.substr(1).split('&')
    for (var i = 0; i < params.length; i++) {
      var keyValue = params[i].split('=')
      if (keyValue.length) {
        qp[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1])
      }
    }
  }
  // Update sort_by query parameter on select change
  document.querySelector('#sort-by').addEventListener('change', function (e) {
    var value = e.target.value
    qp.sort_by = value
    location.search = new URLSearchParams(qp).toString()
  })
}

$('.main-collection-grid-type').on('click', function () {
  $('.main-collection-grid-type').removeClass('main-collection-grid-type--active')
  $(this).addClass('main-collection-grid-type--active')

  if ($(this).hasClass('main-collection-grid-type--threes')) {
    $('.main-collection-grid').addClass('main-collection-grid--3')
  } else {
    $('.main-collection-grid').removeClass('main-collection-grid--3')
  }
})
